//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from '../common/helpers/HttpHelper'
import environments from '../common/environments/environment';
const http = new httpHelper();


export const UserAccountsActions = {
    GetUserAccountsJSON: getUserAccountsJSON,
    GetAllUsers: getAllUsers
}

function getUserAccountsJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.USER_ACCOUNTS_JSON);
}

function getAllUsers() {
    return http.adminGet(environments.USERS);
}
